import { Vars } from './../model/vars';
import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum'; 
import { AbsenceLeave} from '../entities/absence-leave'; 
import { Observable } from 'rxjs/Observable';
import { map , tap} from 'rxjs/operators';
import { catchError  } from 'rxjs/operators';
import { ExecutingUnit } from '../entities/executingUnit';
import { EmployeeTtype } from '../entities/employeeTtype';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Hhelpdesk } from '../entities/hhelpdesk';
import { Absence } from '../entities/absence';
import { CostCenter } from '../entities/costCenter';
import { Employee } from '../entities/employee';


interface ExtraSearchFields { 
  object? :any;
  executingUnit?: ExecutingUnit, 
  employeeType?: EmployeeTtype,
  startDateRange01?: Date,
  startDateRange02?: Date, 
  absenceType : Hhelpdesk , 
  absence : Absence ,
  costCenter : CostCenter,
  employee : Employee
}

@Injectable()
export class ReportAbsenceLeaveDateService extends BaseReportService<AbsenceLeave> {

  public uri = '/api/reportAbsenceLeaveByDay/';

  constructor(injector: Injector) {
    super(injector);
    //console.log('Instance ReportAbsenceDetailService');
  }
  
  buildSentence(entity?: AbsenceLeave, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      
      query = query.concat(
        extraSearchFields && extraSearchFields.employeeType ?
          `employeeType.id${QueryOperator.Equal}${extraSearchFields.employeeType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.startDateRange01 ?
          // tslint:disable-next-line:max-line-length
          `checkOutTime${QueryOperator.GreaterThanOrEqual}${extraSearchFields.startDateRange01.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.startDateRange02 ?
          // tslint:disable-next-line:max-line-length
          `checkInTime${QueryOperator.LessThanOrEqual}${extraSearchFields.startDateRange02.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.absenceType ?
          // tslint:disable-next-line:max-line-length
          `absenceType.id${QueryOperator.Equal}${extraSearchFields.absenceType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.absence ?
          // tslint:disable-next-line:max-line-length
          `absence.id${QueryOperator.Equal}${extraSearchFields.absence.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.costCenter ?
          // tslint:disable-next-line:max-line-length
          `costCenter.id${QueryOperator.Equal}${extraSearchFields.costCenter.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.employee ?
          // tslint:disable-next-line:max-line-length
          `employee.id${QueryOperator.Equal}${extraSearchFields.employee.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  } 
  
  searchToReport(entity?: AbsenceLeave, event?: LazyLoadEvent,
    extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<AbsenceLeave>> {

    const url = `${this.rutaServidor}${this.uri}search`;
    this.spinnerService.showAll();
    const httpParams = this.buildSentence(entity, event, extraSearchFields);
    return this.httpClient.get<ResponsePageable<AbsenceLeave>>(url, { params: httpParams })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.convertToDate(value);
            })
          } 
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  searchToViewTable(   fiscalYear:any,
    executingUnit:any,
    employeeType:any,
    startDateRange01:any,
    startDateRange02:any,
    absenceType:any,
    absence:any,
    costCenter:any,
    employee:any,
    reportType:any,
    formatDate:any,
    object:Vars 
    ): Observable<any> {
      var params = new HttpParams()
        .set('fiscalYear',fiscalYear)
        .set('executingUnit',executingUnit) 
        .set('employeeType', employeeType)
        .set('startDateRange01', startDateRange01)
        .set('startDateRange02', startDateRange02)
        .set('absenceType', absenceType)
        .set('absence', absence)
        .set('costCenter', costCenter)
        .set('employee', employee)
        .set('reportType', reportType)
        .set('formatDate', formatDate) 
       //console.log(event);
       
console.log(params);
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`; 
        return this.httpClient.post<any>(url, object ,{params},)
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            return response;
          })
       ); 
  } 
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-absence-leave-date.service.ts